define('mustache-language/lib/language-hash',{});
